import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { FinancialReportReceiptSettings } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useFinancialReportReceiptSettingsQuery = () => {
  const branchId = useBranchId();

  const query = useQuery<FinancialReportReceiptSettings>({
    queryKey: ["financialPrintSettings", branchId],
    queryFn: () => {
      return get2(
        `/internal/secure/pos/v1/financials/print/settings/${branchId}`
      );
    },
    refetchOnWindowFocus: false,
  });

  return { query };
};

export default useFinancialReportReceiptSettingsQuery;
